export enum ColumnKey {
  Date = 'date',
  BalanceBefore = 'balanceBefore',
  PaymentsResult = 'paymentsResult',
  CorrectionPaymentsResult = 'correctionPaymentsResult',
  WriteOffs = 'writeOffs',
  BalanceAfter = 'balanceAfter',
  Check = 'check',
}

export const columnKeysLeft = [ColumnKey.Date]

export const columnKeysMain = [
  ColumnKey.BalanceBefore,
  ColumnKey.PaymentsResult,
  ColumnKey.CorrectionPaymentsResult,
  ColumnKey.WriteOffs,
  ColumnKey.BalanceAfter,
  ColumnKey.Check,
]

export const headerCells = {
  [ColumnKey.Date]: 'Дата',
  [ColumnKey.BalanceBefore]: 'Баланс\u00A0на\u00A0начало\u00A0дня',
  [ColumnKey.PaymentsResult]: 'Пополнения',
  [ColumnKey.CorrectionPaymentsResult]: 'Пополнения корректирующие',
  [ColumnKey.WriteOffs]: 'Списания',
  [ColumnKey.BalanceAfter]: 'Баланс\u00A0на\u00A0конец\u00A0дня',
  [ColumnKey.Check]: 'Сверка',
}

export const getHeaderCells = (currency: string): Record<ColumnKey, string> => {
  return Object.fromEntries(
    Object.entries(headerCells).map(([key, value]) => {
      if (key === ColumnKey.Date) {
        return [key as ColumnKey, value]
      } else {
        return [key as ColumnKey, `${value},\u00A0${currency}`]
      }
    }),
  ) as Record<ColumnKey, string>
}

export const headerCellsProps = {
  [ColumnKey.Date]: {
    width: 100,
    alignLeft: true,
    bgFilled: true,
  },
  [ColumnKey.BalanceBefore]: {
    borderRight: true,
    ignoreFirstChild: true,
    bgFilled: true,
    alignRight: true,
  },
  [ColumnKey.PaymentsResult]: {
    borderRight: true,
    bgFilled: true,
    alignRight: true,
  },
  [ColumnKey.CorrectionPaymentsResult]: {
    borderRight: true,
    bgFilled: true,
    alignRight: true,
  },
  [ColumnKey.WriteOffs]: {
    borderRight: true,
    bgFilled: true,
    alignRight: true,
  },
  [ColumnKey.BalanceAfter]: {
    borderRight: true,
    bgFilled: true,
    alignRight: true,
  },
  [ColumnKey.Check]: {
    borderRight: true,
    bgFilled: true,
    alignRight: true,
  },
}

export const cellsProps = {
  [ColumnKey.Date]: { alignLeft: true, width: 100 },
  [ColumnKey.BalanceBefore]: {
    alignRight: true,
    borderRight: true,
    ignoreFirstChild: true,
  },
  [ColumnKey.PaymentsResult]: { alignRight: true, borderRight: true },
  [ColumnKey.CorrectionPaymentsResult]: { alignRight: true, borderRight: true },
  [ColumnKey.WriteOffs]: { alignRight: true, borderRight: true },
  [ColumnKey.BalanceAfter]: { alignRight: true, borderRight: true },
  [ColumnKey.Check]: { alignRight: true },
}
